import React from 'react';
import { Avatar } from '../../../../atoms/Avatar';
import { TableDataCaseView } from './TableDataCase.view';
import { Icon } from '../../../../atoms/Icons';

export interface DataTableCaseProps {
  variant: 'rank' | 'note' | 'data' | 'avatar' | 'icon' | 'name';
  icon?: Icon;
  color?:
    | 'normal'
    | 'red'
    | 'green'
    | 'blur'
    | 'transparent'
    | 'grey'
    | 'orange'
    | 'orangeOutlined'
    | 'orangeOutlinedGrey';
  data?: string | number | JSX.Element;
  source?: string;
  alt?: string;
  onClick?: () => void;
}

export const TableDataCase = ({
  variant,
  icon,
  color,
  data,
  source,
  alt,
  onClick
}: DataTableCaseProps) => {
  let line1;

  if (variant === 'rank' || variant === 'data' || variant === 'name') {
    line1 = data;
  } else if (variant === 'note') {
    line1 = `${data} / 20`;
  } else if (variant === 'avatar') {
    line1 = <Avatar alt={alt} source={source} variant={'extrasmall'} />;
  }

  return (
    <TableDataCaseView
      onClick={onClick}
      line1={line1}
      variant={variant}
      icon={icon}
      color={color}
    />
  );
};
